import { createBrowserHistory } from "history";

const history = createBrowserHistory({ basename: "/canopy" });

// This can be used in tests as well as in production code
export default history;
